require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ./~/angular-messages/index.js
// module id = 890
// module chunks = 1